export default __webpack_public_path__ + "static/media/medication.dc325b5f.svg";